import { useState, useEffect } from 'react';
import { IProductAvailabilityItem } from '../../../../TypewriterModels/IProductAvailabilityItem';

export const useProductAvailability = (
    productAvailabilityData: IProductAvailabilityItem[]
) => {
    const [categories, setCategories] = useState<string[]>([]);

    useEffect(() => {
        if (productAvailabilityData) {
            setCategories(
                productAvailabilityData.reduce(
                    (
                        catogeoriesArray: string[],
                        productAvailabilityObject: IProductAvailabilityItem
                    ) => {
                        if (
                            !catogeoriesArray.some(
                                (category) =>
                                    category ===
                                    productAvailabilityObject.category
                            )
                        ) {
                            catogeoriesArray.push(
                                productAvailabilityObject.category
                            );
                        }
                        return catogeoriesArray;
                    },
                    []
                )
            );
        }
    }, []);

    return categories;
};
